import { render, staticRenderFns } from "./VIPRecord.vue?vue&type=template&id=5629756c&scoped=true&"
import script from "./VIPRecord.vue?vue&type=script&lang=js&"
export * from "./VIPRecord.vue?vue&type=script&lang=js&"
import style0 from "./VIPRecord.vue?vue&type=style&index=0&id=5629756c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629756c",
  null
  
)

export default component.exports